import type { FC, ReactNode } from "react";
import styles from "./CardPros.module.scss";
import { classNames } from "../../../../shared/lib/classNames";

interface CardProsProps {
    icon: ReactNode;
    title: ReactNode;
    description: ReactNode;
    className?: string;
}

export const CardPros: FC<CardProsProps> = ({ icon, title, description, className }) => (
    <section
        className={classNames({
            cls: styles.wrapper,
            additional: [className],
        })}
    >
        {icon}
        <div className={styles.content}>
            <div className={styles.title__wrapper}>
                <h4 className={styles.title}>{title}</h4>
            </div>
            <p className={styles.description}>{description}</p>
        </div>
    </section>
);
